import { createTheme } from "@mui/material";

import type { Shadows } from "@mui/material/styles";

const CARD_SHADOW = "rgba(149, 157, 165, 0.2) 0px 8px 24px";

// MUI's defaults, with elevation 1 replaced. Read from a throwaway theme rather than
// hardcoding 25 strings, and copied so nothing mutates a theme MUI already built.
const { shadows: defaultShadows } = createTheme();

export const shadows = [...defaultShadows] as Shadows;
shadows[1] = CARD_SHADOW;
